import { CloseOutlined } from '@ant-design/icons';
import {
  makeIconShape,
  SEXUAL_ACTIVITY_COLORS,
  SEXUAL_ACTIVITY_ICON_PATHS,
} from 'components/charts/SexualActivityChart';
import { palette } from 'design';

/**
 * Swatches for the vaginal-discharge tracker.
 *
 * This is a categorical scale, not an ordinal one — "creamy" is not more or
 * less than "sticky" — so the colours are chosen to be told apart rather than
 * to form a ramp. They are drawn from across the brand families and separated
 * in lightness as well as hue, so they remain distinguishable to a
 * red/green-colour-blind reader and in greyscale.
 *
 * `SPOTTING` is the one entry with a literal association to keep: it stays in
 * the coral family, deep enough to read as blood rather than as decoration.
 */
export const VAGINAL_DISCHARGE_COLORS: Record<string, string> = {
  // Same tone as sexual activity's own "none" (`text.disabled`) — not
  // `neutral200`, a background-weight grey that was barely visible as an
  // icon fill.
  NONE: SEXUAL_ACTIVITY_COLORS.NONE,
  SPOTTING: palette.coral[600],
  STICKY: palette.teal[500],
  CREAMY: palette.sand[300],
  EGG_WHITE: palette.mint[200],
  UNUSUAL: palette.coral[400],
};

// "Aucune" (no discharge) reads better as a small X than as a colour dot — a
// colour can't represent "none" the way it represents every other option —
// so both the calendar scatter and its legend get the same close-icon shape
// the sexual-activity chart already uses for its own "none" value.
const VAGINAL_DISCHARGE_NONE_SHAPE = makeIconShape(
  SEXUAL_ACTIVITY_ICON_PATHS.NONE,
  '64 64 896 896',
  VAGINAL_DISCHARGE_COLORS.NONE,
);
export const VAGINAL_DISCHARGE_SHAPE_MAP = { NONE: VAGINAL_DISCHARGE_NONE_SHAPE };
export const VAGINAL_DISCHARGE_ICON_MAP = {
  NONE: <CloseOutlined style={{ fontSize: 12, color: VAGINAL_DISCHARGE_COLORS.NONE, marginRight: 4 }} />,
};
